<div [formGroup]="form" class="flex flex-col bg-white rounded-xl h-full mb-3">

  <div *ngIf="isLoading; else loadedTemp" class="p-3 text-sm">{{'labels.loading-data' | translate}}</div>
  <ng-template #loadedTemp class="h-full">
    <div class="text-base font-semibold my-5 ml-4">{{'data-sharing.select-for-sharing' | translate}}</div>

    <mat-form-field appearance="outline" class="w-auto mx-3 rounded-xl" hideRequiredMarker>
      <mat-label>{{'data-sharing.find-vehicle' | translate}}</mat-label>
      <input matInput type="text" formControlName="search" autocomplete="false" maxlength="50">
    </mat-form-field>

    <app-button id="btn-select-all" class="ml-3 mb-3" [isActive]="true" innerTextClasses="text-sm"
                label="{{'labels.select-all' | translate}} ({{this.dataSource.filteredData.length}})"
                (click)="onSelectAll()"></app-button>

    <div class="overflow-y-auto" style="height: calc(100vh - 385px)">
      <table mat-table recycleRows [dataSource]="dataSource" class="w-full shadow-none bg-white ">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="bg-white text-black font-normal"></th>
          <td mat-cell *matCellDef="let row" class="text-xs">
            <mat-checkbox (click)="$event.stopPropagation();"
                          (change)="$event ? selectionModel.toggle(row) : null"
                          [checked]="selectionModel.isSelected(row)">
              <div class="break-all">{{row.Nm}}</div>
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{'data-sharing.column-name' | translate}}</th>
          <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="tk-panel-bg hidden"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-pointer"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td clas="mat-cell" colspan="5">
            <div class="ml-2 text-sm font-bold">{{'labels.no-data' | translate}}</div>
          </td>
        </tr>
      </table>
    </div>

  </ng-template>

</div>
